let base = window._env_.VUE_APP_ADMIN_HOST



export const getPriceBatchTable = params => {
  return axios.get(`${base}/task_dynamic_salary/query`, params)
}
export const createPriceBatch = params => {
  return axios.post(`${base}/task_dynamic_salary/create`, params)
}
export const searchPriceBatchItems = params => {
  return axios.get(`${base}/task_dynamic_salary/search_info`, {params})
}
export const downloadPriceBatch = id => {
  return `${base}/excel/down_sourc_file_${id}`
}



// WEBPACK FOOTER //
// ./src/views/price-batch/price-batch.api.js